import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const usePreventBackNavigation = () => {
  const navigate = useNavigate()

  const popListener = useCallback(
    (e: PopStateEvent) => {
      e.preventDefault()
      // reload the app to avoid the back button to navigate back to the previous page
      // and then it will load the correct step
      navigate(0)
    },
    [navigate],
  )

  useEffect(() => {
    window.addEventListener('popstate', popListener)

    return () => {
      window.removeEventListener('popstate', popListener)
    }
  }, [navigate])
}
